//add the frequency per device (can gives data per minute but based on the frequency the data will plot and alert on client side)
import React, { useState, useEffect, useRef } from "react";
import Sidebar from "./Sidebar";
import ClientPanel from "./ClientPanel";
import DevicePanel from "./DevicePanel";
import MappingPanel from "./MappingPanel";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
const REACT_FE = process.env.REACT_APP_FE_BASE

function AdminDashboard() {
  const [isOpen, setIsOpen] = useState(true);
  const [activePanel, setActivePanel] = useState("dashboard");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef();

  const [clients, setClients] = useState([]);
  const [devices, setDevices] = useState([]);
  const [mappings, setMappings] = useState([]);
  const [nextDeviceID, setNextDeviceID] = useState("");


  // New state declarations for selection toggles
  const [selectedClientSummary, setSelectedClientSummary] = useState(false);
  const [selectedTotalDevices, setSelectedTotalDevices] = useState(false);
  const [selectedEnabledDevices, setSelectedEnabledDevices] = useState(false);
  const [selectedActiveDevices, setSelectedActiveDevices] = useState(false);
  const [selectedFaultyDevices, setSelectedFaultyDevices] = useState(false);

  const navigate = useNavigate();

  const handleLogout = () => {
    Cookies.remove("auth");        // Remove auth token or flags
    Cookies.remove("clientId");    // If you store clientId or session info
    navigate("/");                 // Navigate to login page ("/" or "/login" as per your route)
  };


  // Fetch data
  const fetchMappings = async () => {
    try {
      const res = await axios.get(`${REACT_FE}/api/mappings`);
      setMappings(res.data);
    } catch (error) {
      console.error("Error fetching mappings:", error);
    }
  };


  const fetchDevices = async () => {
    try {
      const res = await axios.get(`${REACT_FE}/api/devices`);
      setDevices(res.data);
    } catch (error) {
      console.error("Error fetching devices:", error);
    }
  };

  const fetchClients = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(`${REACT_FE}/api/clients`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setClients(res.data);
    } catch (err) {
      console.error("Failed to fetch clients:", err.response?.data || err.message);
    }
  };

  useEffect(() => {
    fetchClients();
    fetchDevices();
    fetchMappings();
  }, []);


  // Sidebar toggles
  const toggleSidebar = () => setIsOpen(!isOpen);
  const toggleDropdown = () => setShowDropdown(!showDropdown);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Calculate device summaries
  const totalDevices = devices.length;
  const enabledDevices = devices.filter((d) => d.isEnabled).length;
  const activeDevices = devices.filter((d) => d.isActive).length;
  const faultyDevices = devices.filter((d) => d.isFaulty).length;

  return (
    <div style={{ minHeight: "100vh" }}>
      {/* Top Bar */}
      <div
        className="position-fixed top-0 start-0 w-100 px-4 py-2 bg-light d-flex justify-content-between align-items-center"
        style={{ zIndex: 1050, height: "60px", borderBottom: "1px solid #ccc" }}
      >
        <button
          className="btn btn-outline-light bg-dark border-0"
          onClick={toggleSidebar}
        >
          &#9776;
        </button>

        <div className="d-flex align-items-center gap-3">
          <img
            src="/EulerianBots.jpeg"
            alt="Eulerian Bots Logo"
            className="position-absolute"
            style={{
              left: "80px",
              top: "50%",
              transform: "translateY(-50%)",
              height: "40px",
              objectFit: "contain",
              zIndex: 1051,
            }}
          />
          <img
            src="/FiverLogo.png"
            alt="Eulerian Bots Logo"
            style={{ height: "40px", objectFit: "contain", marginLeft: "1275px" }}
          />
        </div>

        {/* Profile Dropdown */}
        <div className="position-relative" ref={dropdownRef}>
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "bold", color: "black" }}>Psitech</span>
            <button
              className="btn btn-sm btn-light border"
              onClick={toggleDropdown}
              style={{ lineHeight: "1", padding: "4px 6px" }}
            >
              &#9662;
            </button>
          </div>
          {showDropdown && (
            <div
              className="position-absolute bg-white border shadow rounded mt-2"
              style={{ right: 0, top: "100%", minWidth: "160px", zIndex: 2000 }}
            >
              <ul className="list-unstyled mb-0" style={{ margin: 0 }}>

                <li>
                  <button
                    className="dropdown-item"
                    style={{
                      padding: "6px 12px",
                      fontSize: "0.95rem",
                      lineHeight: "1.4",
                      color: "black",
                    }}
                  >
                    Settings
                  </button>
                </li>
                <li>
                  <hr className="dropdown-divider my-1" />
                </li>
                <li>
                  <button
                    className="dropdown-item text-danger"
                    style={{
                      padding: "6px 12px",
                      fontSize: "0.95rem",
                      fontWeight: "bold",
                      lineHeight: "1.4",
                    }}
                    onClick={handleLogout}
                  >
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>

      <div
        style={{
          display: "flex",
          marginTop: "60px", // the height of the top bar
        }}
      >
        {/* SIDEBAR */}
        <div
          style={{
            width: isOpen ? "250px" : "0px",
            transition: "width 0.5s ease",
            overflow: "hidden",
          }}
        >
          <Sidebar isOpen={isOpen} setActivePanel={setActivePanel} setNextDeviceID={setNextDeviceID} />
        </div>

        {/* MAIN CONTENT */}
        <div
          style={{
            flex: 1, // take remaining horizontal space
            display: "flex",
            flexDirection: "column",
            alignItems: "center", // centers all content horizontally
            padding: "20px",
          }}
        >
          {/* Dashboard view */}
          {activePanel === "dashboard" && (
            <>
              <div className="d-flex gap-4 mb-4">
                {/* Clients Box */}
                <div
                  className="bg-light text-dark rounded p-5 shadow-lg"
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.8rem",
                    minWidth: "300px",
                    minHeight: "150px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "10px",
                  }}
                >
                  Clients
                  <div
                    onClick={() =>
                      setSelectedClientSummary((prevSelected) => !prevSelected)
                    }
                    className="rounded mt-3 p-2"
                    style={{
                      fontSize: "1.2rem",
                      width: "100%",
                      textAlign: "center",
                      cursor: "pointer",
                      borderRadius: "10px",
                      backgroundColor: selectedClientSummary ? "#0d6efd" : "white",
                      color: selectedClientSummary ? "white" : "black",
                      border: selectedClientSummary ? "2px solid #0d6efd" : "1px solid #ccc",
                      transition: "all 0.3s ease",
                    }}
                    title="Click to select this summary"
                  >
                    Total: {clients.length}
                  </div>
                </div>

                {/* Devices Box */}
                <div
                  className="bg-light text-dark rounded p-5 shadow-lg"
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.8rem",
                    minWidth: "300px",
                    minHeight: "150px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "10px",
                  }}
                >
                  Devices
                  <div
                    className="d-flex flex-wrap gap-2 mt-3"
                    style={{ justifyContent: "center" }}
                  >
                    {/* Total Devices */}
                    <div
                      onClick={() =>
                        setSelectedTotalDevices((prevSelected) => !prevSelected)
                      }
                      className="rounded p-2"
                      style={{
                        fontSize: "1.1rem",
                        width: "140px",
                        textAlign: "center",
                        cursor: "pointer",
                        backgroundColor: selectedTotalDevices ? "#0d6efd" : "white",
                        color: selectedTotalDevices ? "white" : "black",
                        border: selectedTotalDevices ? "2px solid #0d6efd" : "1px solid #ccc",
                        borderRadius: "10px",
                        transition: "all 0.3s ease",
                      }}
                      title="Click to select this summary"
                    >
                      Total: {devices.length}
                    </div>
                    {/* Enabled Devices */}
                    <div
                      onClick={() =>
                        setSelectedEnabledDevices((prevSelected) => !prevSelected)
                      }
                      className="rounded p-2"
                      style={{
                        fontSize: "1.1rem",
                        width: "140px",
                        textAlign: "center",
                        cursor: "pointer",
                        backgroundColor: selectedEnabledDevices ? "#0d6efd" : "white",
                        color: selectedEnabledDevices ? "white" : "black",
                        border: selectedEnabledDevices ? "2px solid #0d6efd" : "1px solid #ccc",
                        borderRadius: "10px",
                        transition: "all 0.3s ease",
                      }}
                      title="Click to select this summary"
                    >
                      Enabled: {devices.filter((d) => d.isEnabled).length}
                    </div
                    >
                    {/* Active Devices */}
                    <div

                      onClick={() =>
                        setSelectedActiveDevices((prevSelected) => !prevSelected)
                      }
                      className="rounded p-2"
                      style={{
                        fontSize: "1.1rem",
                        width: "140px",
                        textAlign: "center",
                        cursor: "pointer",
                        backgroundColor: selectedActiveDevices ? "#0d6efd" : "white",
                        color: selectedActiveDevices ? "white" : "black",
                        border: selectedActiveDevices ? "2px solid #0d6efd" : "1px solid #ccc",
                        borderRadius: "10px",
                        transition: "all 0.3s ease",
                      }}
                      title="Click to select this summary"
                    >
                      Active: {devices.filter((d) => d.isActive).length}
                    </div>
                    {/* Faulty Devices */}
                    <div
                      onClick={() =>
                        setSelectedFaultyDevices((prevSelected) => !prevSelected)
                      }
                      className="rounded p-2"
                      style={{
                        fontSize: "1.1rem",
                        width: "140px",
                        textAlign: "center",
                        cursor: "pointer",
                        backgroundColor: selectedFaultyDevices ? "#0d6efd" : "white",
                        color: selectedFaultyDevices ? "white" : "black",
                        border: selectedFaultyDevices ? "2px solid #0d6efd" : "1px solid #ccc",
                        borderRadius: "10px",
                        transition: "all 0.3s ease",
                      }}
                      title="Click to select this summary"
                    >
                      Faulty: {devices.filter((d) => d.isFaulty).length}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {activePanel === "clients" && (
            <ClientPanel clients={clients} fetchClients={fetchClients} />
          )}

          {activePanel === "devices" && (
            <DevicePanel devices={devices} fetchDevices={fetchDevices} nextDeviceID={nextDeviceID} />
          )}

          {activePanel === "deviceMapping" && (
            <MappingPanel
              clients={clients}
              devices={devices}
              mappings={mappings}
              fetchMappings={fetchMappings}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;





